'use strict';

MultiFragmentRequesterClassFactory.$inject = [
	'$q',
	'mx.SolutionBuilderAgent.DataQueryService',
	'mx.shell.ObjectMapper',
	'mx.SolutionBuilderAgent.ContentWidgetService',
	'mx.SolutionBuilderAgent.Http',
	'mx.shell.DownloadHelpService',
	'mx.sb.Agent.DataQuery.ClientDataRequester',
	'mx.sb.Agent.DataQuery.Row',
	'mx.sb.Agent.DataQuery.Enums',
];
export default function MultiFragmentRequesterClassFactory(
	$q,
	dataQueryService,
	objectMapper,
	contentWidgetService,
	http,
	downloadHelpService,
	ClientDataRequester,
	DataQueryRow,
	DataQueryEnums
) {
	/**
	 * @ngdoc Class
	 * @name mx.sb.Agent.DataQuery.MultiFragmentRequester
	 *
	 * @description
	 * Class DataDefinition Requester
	 *
	 */

	function MultiFragmentRequester(dataQuery) {
		ClientDataRequester.call(this, dataQuery);

		this.options = {};
	}

	MultiFragmentRequester.prototype = angular.extend(Object.create(ClientDataRequester.prototype), {
		_loadExpressions: function (rawEntity, displayEntity, changedColumns) {
			var queryColumns = changedColumns.filter(function (column) {
				return column.HasQuery;
			});

			var expressions = queryColumns
				.map(function (column) {
					return {
						Name: column.Name,
						Expression: column.Expression,
						Values: column.ExpressionDependencies.map(function (fieldName) {
							return {
								Key: fieldName,
								Value: rawEntity[fieldName],
							};
						}),
					};
				})
				.filter(function (expression) {
					//TODO: server side should be fixed to work with null values and then this filter should be removed
					return expression.Values.filter(function (value) {
						return value.Value !== null;
					}).length;
				});

			return (
				expressions.length > 0
					? dataQueryService
							.executeMultiFragmentExpressions({
								expressions: expressions,
								className: this.options.entityClassName,
								typeName: this.options.entityName, //TODO: need to get entityName from DataModel by property
							})
							.then(
								function (results) {
									return results;
								},
								function () {
									return [];
								}
							)
					: $q.when([])
			).then(function (results) {
				return changedColumns.filter(function (column) {
					var result = _.find(results, { Name: column.Name });
					if (result) {
						displayEntity[column.Name] = result.DisplayString;
						return false;
					} else if (column.IsSingleColumn && rawEntity.hasOwnProperty(column.Name) && typeof rawEntity[column.Name] !== 'undefined') {
						displayEntity[column.Name] = rawEntity[column.Name];
						return false;
					}
					return true;
				});
			});
		},

		_getDisplayEntity: function (rawEntity, displayEntity, changedColumns) {
			var defer = $q.defer();

			//Steps to get display entity for Columns with Expressions in multifragment-grid:
			// 1. loadExpression from server for this column
			// 3. if loadExpression doesn't return value for column, this column is SingleColumn and rawValue has 'column.Name' property => use rawValue
			// 4. check enums and pickers display names

			this._loadExpressions(rawEntity, displayEntity, changedColumns).then(function (simpleChangedColumns) {
				ClientDataRequester.prototype._getDisplayEntity
					.call(this, rawEntity, displayEntity, simpleChangedColumns)
					.then(function (displayEntity) {
						defer.resolve(displayEntity);
					})
					.catch(function (e) {
						defer.reject(e);
					});
			});

			return defer.promise;
		},

		_getRows: function () {
			var dataQuery = this.dataQuery;

			if (
				this.rows &&
				this.rows.length === this.options.items.length &&
				this._items === this.options.items &&
				this._dataQuery &&
				this._dataQuery === dataQuery &&
				this.options.objectId === this._objectId
			) {
				return $q.when(this._getFilteredRows(this.rows));
			}

			this._items = this.options.items;
			this._dataQuery = dataQuery;
			this._objectId = this.options.objectId;

			var promise =
				dataQuery.Id && this.options.objectId && this.options.objectId !== 'new'
					? dataQueryService.getMultiFragmentData(dataQuery.Id, this.options.objectId)
					: $q.resolve([]);

			return promise.then(
				function (items /*, response*/) {
					var displayEntities = {};

					items.forEach(function (item) {
						displayEntities[item.Id] = objectMapper.mapItem(item);
					});

					return $q
						.all(
							this.options.items.map(function (rawEntity) {
								var row = new DataQueryRow(rawEntity, displayEntities[rawEntity.ID], this._getDisplayEntity.bind(this));
								return row.initProperties(dataQuery.Columns).then(function () {
									return row;
								});
							}, this)
						)
						.then(
							function (rows) {
								this.rows = rows;
								return this._getFilteredRows(rows);
							}.bind(this)
						);
				}.bind(this)
			);
		},

		createEntity: function (entityClassName) {
			return contentWidgetService.getNewFragment(entityClassName);
		},

		getEntityTypes: async function () {
			return [
				{
					_displayName: '',
					_type: this.dataQuery.SchemaClassName,
					_itemType: 'multifragment',
				},
			];
		},

		exportData: function (preprocessors) {
			var request = {
				DataQueryId: this.dataQuery.Id,
				ClientTimeOffset: new Date().getTimezoneOffset(),
				ObjectId: this.options.objectId,
				Columns: this.dataQuery.Columns.filter((column) => column.visible)
					.map((column) => column.Name)
					.join(','),
				Keyword: preprocessors?.searchPreprocessor?.keyword,
				ActiveFilter: preprocessors?.columnSearchPreprocessor?.conditions,
				OrderBy: (preprocessors?.sortingPreprocessor?.sortedColumns || []).reduce(
					(accum, column, i) => accum + (i > 0 ? ',' : '') + column.Name + ' ' + (column.Sorting === DataQueryEnums.ColumnSortingEnum.Ascending ? 'asc' : 'desc'),
					''
				),
			};

			var headers = {
				responseType: 'arraybuffer',
			};

			return http.post('api/DataObject/ExportObjectFragments', request, headers, {}, false, true).then(function (response) {
				return downloadHelpService.downloadContent(response, response.data);
			});
		},
	});

	return MultiFragmentRequester;
}
